/**
 * 文档有什么权限
 */
export var DOCUMENT_PRIVILEGE = /*#__PURE__*/function (DOCUMENT_PRIVILEGE) {
  DOCUMENT_PRIVILEGE[DOCUMENT_PRIVILEGE["deny"] = 0] = "deny";
  DOCUMENT_PRIVILEGE[DOCUMENT_PRIVILEGE["whitelist"] = 1] = "whitelist";
  DOCUMENT_PRIVILEGE[DOCUMENT_PRIVILEGE["allOnlyRead"] = 2] = "allOnlyRead";
  DOCUMENT_PRIVILEGE[DOCUMENT_PRIVILEGE["allOnlyWrite"] = 3] = "allOnlyWrite";
  DOCUMENT_PRIVILEGE[DOCUMENT_PRIVILEGE["allOnlyExecute"] = 4] = "allOnlyExecute";
  DOCUMENT_PRIVILEGE[DOCUMENT_PRIVILEGE["invalidPolicy"] = 999] = "invalidPolicy";
  return DOCUMENT_PRIVILEGE;
}({});
export var CORP_POLICY = {
  DENY: 0,
  WHITELIST: 1,
  ALL_ONLY_READ: 2,
  ALL_ONLY_WRITE: 3,
  ALL_ONLY_EXECUTE: 4
};

/**
 * 是否显示批注的枚举
 * 0 为默认(显示)，1 为显示，2 为不显示
 */
export var COMMENT_BOX_STATUS = {
  DEFAULT: 0,
  SHOW: 1,
  HIDE: 2
};

/**
 * 文档权限
 */
export var POLICY = {
  SELF: 0,
  COOPERATION: 1,
  VIEWABLE: 2,
  EDITABLE: 3
};

/**
 * 当前用户拥有的对当前文档的能力
 */

/**
 * 权限过期时间
 */

/**
 * 文档的高级权限
 */

/**
 * 协作空间设置权限的 CGI 传入参数
 */
//# sourceMappingURL=entity.js.map